var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33958 2.89982L3.86624 8.69315C3.65958 8.91315 3.45958 9.34649 3.41958 9.64649L3.17291 11.8065C3.08624 12.5865 3.64624 13.1198 4.41958 12.9865L6.56624 12.6198C6.86624 12.5665 7.28624 12.3465 7.49291 12.1198L12.9662 6.32649C13.9129 5.32649 14.3396 4.18649 12.8662 2.79315C11.3996 1.41315 10.2862 1.89982 9.33958 2.89982Z",
    stroke: "#3186FD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 3.86621C8.71342 5.70621 10.2068 7.11288 12.0601 7.29954",
    stroke: "#3186FD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.167H14.5",
    stroke: "#3186FD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.1bf246c3cb789ddad504b1874d0be5ac.svg";
export { ForwardRef as ReactComponent };